import clsx from "clsx";
import { MissionControlCard } from "@/components/mission-control/MissionControlCard";
import { formatRelativeTime } from "@/components/missions/MissionRow";
import type { ScreeningDocument } from "@/services/api/guardiansv2/types";
import { screeningListSubtitle, screeningListTitle } from "./screeningPresentation";

export interface ScreeningCardProps {
  screening: ScreeningDocument;
  selected?: boolean;
  onClick: () => void;
}

export function ScreeningCard({ screening, selected, onClick }: ScreeningCardProps) {
  const title = screeningListTitle(screening);
  const subtitle = screeningListSubtitle(screening);
  const raised = screening.outcome.raised_alert;
  const failedCount = screening.checks.failed_count;

  return (
    <MissionControlCard
      selected={selected}
      onClick={onClick}
      data-testid={`screening-card-${screening._id}`}
      title={
        <span className="text-sm font-medium text-slate-100 line-clamp-1">{title}</span>
      }
      titleBadges={
        <span
          className={clsx(
            "inline-flex rounded-md px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide",
            raised ? "bg-amber-500/20 text-amber-200" : "bg-emerald-500/15 text-emerald-300"
          )}
        >
          {raised ? "Alert" : "Passed"}
        </span>
      }
      timestamp={
        <span className="text-xs text-slate-400 tabular-nums">
          {formatRelativeTime(screening.created_at)}
        </span>
      }
      subtitle={
        subtitle || failedCount > 0 ? (
          <span className="mt-1.5 block text-xs text-slate-400 line-clamp-2">
            {subtitle || `${failedCount} failed check${failedCount === 1 ? "" : "s"}`}
            {screening.catalogue_key ? ` · ${screening.catalogue_key}` : ""}
          </span>
        ) : null
      }
    />
  );
}
